import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

interface IconShape {
  paths: readonly string[];
  /** A solid shape (filled) instead of a line. */
  solid?: boolean;
}

const CIRCLE = 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z';

/** The icons of the boards of the tab «Фото и видео» (24 × 24). Lines are drawn with the current colour. */
export const MEDIA_ICONS: Record<string, IconShape> = {
  handle: { solid: true, paths: ['M9 4.4a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zM15 4.4a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zM9 10.4a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zM15 10.4a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zM9 16.4a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zM15 16.4a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2z'] },
  more: { solid: true, paths: ['M5 10.2a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 0 0 0-3.6zM12 10.2a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 0 0 0-3.6zM19 10.2a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 0 0 0-3.6z'] },
  star: { solid: true, paths: ['M12 2.8l2.8 5.8 6.3.9-4.6 4.4 1.1 6.3L12 17.2l-5.6 3 1.1-6.3L2.9 9.5l6.3-.9L12 2.8z'] },
  play: { solid: true, paths: ['M8 5v14l11-7z'] },
  left: { paths: ['m15 5-7 7 7 7'] },
  right: { paths: ['m9 5 7 7-7 7'] },
  down: { paths: ['m6 9 6 6 6-6'] },
  frame: { paths: ['M6 2v14a2 2 0 0 0 2 2h14M18 22V8a2 2 0 0 0-2-2H2'] },
  replace: { paths: ['M4 12a8 8 0 0 1 14-5.3L20 9M20 4v5h-5M20 12a8 8 0 0 1-14 5.3L4 15M4 20v-5h5'] },
  trash: { paths: ['M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3'] },
  plus: { paths: ['M12 5v14M5 12h14'] },
  cloud: { paths: ['M7 18a4.5 4.5 0 0 1-.9-8.9A6 6 0 0 1 17.7 8 4 4 0 0 1 17 18', 'M12 12v9M8.5 15.5 12 12l3.5 3.5'] },
  check: { paths: ['m5 12 5 5 9-10'] },
  info: { paths: [CIRCLE, 'M12 8v5M12 16h.01'] },
  ok: { paths: [CIRCLE, 'm8 12 3 3 5-6'] },
  close: { paths: ['M6 6l12 12M18 6 6 18'] },
  image: { paths: ['M4 5h16v14H4z', 'M4 16l5-5 4 4 3-3 4 4', 'M9 9.5a.5.5 0 1 0 0 .01'] },
  video: { paths: ['M4 6h11v12H4z', 'm15 10 5-3v10l-5-3'] }
};

@Component({
  selector: 'hc-media-icon',
  template: `<svg [attr.width]="size()" [attr.height]="size()" viewBox="0 0 24 24" aria-hidden="true" [attr.fill]="shape().solid ? 'currentColor' : 'none'" [attr.stroke]="shape().solid ? 'none' : 'currentColor'" [attr.stroke-width]="width()" stroke-linecap="round" stroke-linejoin="round">
    @for (d of shape().paths; track d) {
      <path [attr.d]="d"></path>
    }
  </svg>`,
  styles: [':host { display: inline-flex; flex: none; line-height: 0; } svg { display: block; }'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MediaIconComponent {
  readonly name = input.required<string>();
  readonly size = input(16);
  readonly width = input(2);

  protected readonly shape = computed<IconShape>(() => MEDIA_ICONS[this.name()] ?? { paths: [] });
}
